//67
import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import * as THREE from 'three';
import { RGBELoader } from 'three-stdlib';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import {
  Bronze,
  TurnedLegMaterial,
  UpholsteryMaterial,
} from '../../utils/materials';

export function Mia_bench(props) {
  const { nodes, materials, scene } = useGLTF('models/Mia Bench.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    UpholsteryMaterial,
    currentMaterialFinish.upholsteryFinish,
    defaultFinish.upholsteryFinish,
    'ao-mia_bench-upholstery',
    aoIntensity,
  );
  useSetMaterialFinish(
    TurnedLegMaterial,
    currentMaterialFinish.turnedLegFinish,
    defaultFinish.turnedLegFinish,
    "ao-mia_bench-turned_leg_finish",
    aoIntensity,
  );
  const [hdriTexture, setHdriTexture] = useState(null);

  useEffect(() => {
    // Load the HDRI using RGBELoader
    new RGBELoader()
      .setPath('/hdri/') // Set the path to your HDRI folder
      .load('1.hdr', (texture) => {
        texture.mapping = THREE.EquirectangularReflectionMapping;
        setHdriTexture(texture);
      });
  }, []);

  // Create the Chrome material with the loaded envMap
  const BronzeMaterial = Bronze(hdriTexture);

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  if (!hdriTexture) {
    return null; // Return null while HDRI is loading
  }

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Buffer.geometry}
        material={BronzeMaterial}
      />
      <mesh
        castShadow
        geometry={nodes.Upholstery.geometry}
        material={UpholsteryMaterial}
      />
      <mesh
        castShadow
        geometry={nodes.Turned_Leg_Finish.geometry}
        material={TurnedLegMaterial}
      />
      <Shadow model={'Mia Bench'} />
    </group>
  );
}
